import { useEffect } from "react";
import { getPortalUrl } from "../lib/portal-url";
import "./paywall.css";

export interface PaywallModalProps {
  open: boolean;
  onClose: () => void;
  featureTitle?: string;
  portalUrl?: string;
}

const DEFAULT_FEATURES = [
  "Opslaan en laden van presets",
  "Exporteren (bijv. PDF)",
  "Volledige workflow zonder beperkingen",
];

export function PaywallModal({
  open,
  onClose,
  featureTitle = "deze functie",
  portalUrl,
}: PaywallModalProps) {
  const portal = getPortalUrl(portalUrl);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="jari-paywall-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="paywall-modal-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="jari-paywall-modal">
        <h2 id="paywall-modal-title">Licentie vereist</h2>
        <p>
          Om {featureTitle} te gebruiken heb je een betaalde licentie voor deze tool
          nodig via het Interact-GGZ portaal.
        </p>
        <ul>
          {DEFAULT_FEATURES.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <div className="jari-paywall-modal__actions">
          <a href={portal} className="jari-btn jari-btn--primary">
            Licentie afnemen in portal
          </a>
          <button type="button" className="jari-btn" onClick={onClose}>
            Sluiten
          </button>
        </div>
      </div>
    </div>
  );
}
